import Store from '../../src/redux';
import { sendRequestTardeManger, sendRequest, sendRequestV2, sendRequestTarde } from "../api/baseRequest";
const getHeaders = () => {
  const user = Store?.getState()?.user;
  return {
    'X-FNOTRADER-SECRET': user?.loginSecret,
    'X-FNOTRADER-USERID': user?.userID,
    //'Content-Type' : 'text/plain',
    //'Cache-Control' : 'no-cache,no-store',
  };
}

class BrokerService {


  getBrokers(status) {
    if (status) {
      return sendRequestTarde('get', `brokers?status=${status}`, {}, getHeaders());
    } else {
      return sendRequestTarde('get', 'brokers', {}, getHeaders());
    }

  }
  getSuscriptions() {
    return sendRequestTarde('get', 'subscription-payments', {}, getHeaders());
  }

  addBroker(params) {
    return sendRequestTarde('post', 'brokers', params, getHeaders());
  }

  brokerLogin(broker_id, totp) {
    const params = totp ? { totp } : {};
    return sendRequestTarde('post', `brokers/${broker_id}/login`, params, getHeaders());
  }

  brokerLogout(broker_id) {
    return sendRequestTarde('get', `brokers/${broker_id}/logout`, {}, getHeaders());
  }

  deleteBrokers(broker_id) {
    return sendRequestTarde('delete', `brokers/${broker_id}`, {}, getHeaders());
  }

  getjwt() {
    return sendRequestTardeManger('get', 'token', {}, getHeaders());
  }
  placeOrders(parma, broker_id) {
    return sendRequestTardeManger('post', `broker/${broker_id}/place_orders`, parma, getHeaders());
  }

  getSuscriptions() {
    return sendRequestTarde('get', 'subscription-payments', {}, getHeaders());
  }

  getSubscriptionStatus(parma) {
    return sendRequestTarde('post', `subscription-status`, parma, getHeaders());
  }

  ListOrders(broker_id) {
    return sendRequestTardeManger('get', `broker/${broker_id}/orders?type=manual`, {}, getHeaders());
  }

  modifyOrder(parma, broker_id) {
    return sendRequestTardeManger('post', `broker/${broker_id}/modify_order`, parma, getHeaders());
  }

  cancelOrder(parma, broker_id) {
    return sendRequestTardeManger('post', `broker/${broker_id}/cancel_orders`, parma, getHeaders());
  }

  ListPositions(broker_id) {
    return sendRequestTardeManger('get', `broker/${broker_id}/positions?type=manual`, {}, getHeaders());
  }

  chanageBasket(parma) {
    return sendRequestTardeManger('post', `positions/basket/add`, parma, getHeaders());
  }
  removeBasket(parma) {
    return sendRequestTardeManger('post', `positions/basket/remove`, parma, getHeaders());
  }
  brokerSync(broker_id) {
    return sendRequestTardeManger('post', `broker/${broker_id}/sync`, {}, getHeaders());
  }
  brokerResetAndSync(broker_id) {
    return sendRequestTardeManger('post', `broker/${broker_id}/reset-sync`, {}, getHeaders());
  }
  positionsSync(broker_id) {
    return sendRequestTardeManger('post', `broker/${broker_id}/positions/sync`, {}, getHeaders());
  }
  ordersSync(broker_id) {
    return sendRequestTardeManger('post', `broker/${broker_id}/orders/sync`, {}, getHeaders());
  }
  getSyncStatus(broker_id) {
    return sendRequestTardeManger('get', `broker/${broker_id}/sync/status`, {}, getHeaders());
  }
  getlogs(broker_id) {
    return sendRequestTardeManger('get', `broker/${broker_id}/logs?type=manual`, {}, getHeaders());
  }
  getFunds(broker_id) {
    return sendRequestTardeManger('get', `broker/${broker_id}/funds`, {}, getHeaders());
  }
  getBrokerAlgoLogs(broker_id) {
    return sendRequestTardeManger('get', `broker/${broker_id}/logs?type=algo`, {}, getHeaders());
  }
  getMargin(broker_id, params) {
    return sendRequestTardeManger('post', `broker/${broker_id}/margin`, params, getHeaders());
  }
  getTrades(broker_id) {
    return sendRequestTardeManger('get', `broker/${broker_id}/trades?type=manual`, {}, getHeaders());
  }

  updatePosition(position_id, params) {
    return sendRequestTardeManger('post', `position/${position_id}`, params, getHeaders());
  }

  getPositionPnlMtm(position_id) {
    return sendRequestTardeManger('get', `position/${position_id}/mtm`, {}, getHeaders());
  }

  getBasketPnlMtm(basket_id) {
    return sendRequestTardeManger('get', `basket/${basket_id}/mtm`, {}, getHeaders());
  }

  getStrategyPnlMtm(strategy_id) {
    return sendRequestTardeManger('get', `strategy/${strategy_id}/mtm`, {}, getHeaders());
  }

  getBrokerAlgoMtm(broker_id) {
    return sendRequestTardeManger('get', `broker/${broker_id}/algo/mtm`, {}, getHeaders());
  }

  getBrokerPnlMtm(broker_id) {
    return sendRequestTardeManger('get', `broker/${broker_id}/mtm`, {}, getHeaders());
  }

  getUserPnlMtm(user_id) {
    return sendRequestTardeManger('get', `user/${user_id}/mtm`, {}, getHeaders());
  }

  getUserDashboard(user_id) {
    return sendRequestTardeManger('get', `user/${user_id}/dashboard`, {}, getHeaders());
  }

  updateBasket(basket_id, params) {
    return sendRequestTardeManger('post', `basket/${basket_id}`, params, getHeaders());
  }

  getBasket(basket_id) {
    return sendRequestTardeManger('get', `basket/${basket_id}`, {}, getHeaders());
  }
  updateBasketName(basket_id, params) {
    return sendRequestTardeManger('post', `basket/${basket_id}/name`, params, getHeaders());
  }
  updateInstrumentConfig(basket_id, instrument_token, params) {
    return sendRequestTardeManger('post', `broker/${basket_id}/instrument/${instrument_token}`, params, getHeaders());
  }

  getInstrumentConfig(brokerId, instrument_token) {
    return sendRequestTardeManger('get', `broker/${brokerId}/instrument/${instrument_token}`, {}, getHeaders());
  }

  getBrokerConfig(brokerId) {
    return sendRequestTardeManger('get', `broker/${brokerId}/config`, {}, getHeaders());
  }

  updateBrokerConfig(basket_id, params) {
    return sendRequestTardeManger('post', `broker/${basket_id}/config`, params, getHeaders());
  }

  UpdateBroker(broker_id, params) {
    return sendRequestTardeManger('post', `broker/${broker_id}`, params, getHeaders());
  }

  enableBroker(broker_id, params) {
    return sendRequestTarde('put', `brokers/${broker_id}`, params, getHeaders());
  }

  updateBroker(broker_id, params) {
    return this.UpdateBroker(broker_id, params);
  }

  GetBroker(broker_id) {
    return sendRequestTardeManger('get', `broker/${broker_id}`, {}, getHeaders());
  }
  getBroker(broker_id) {
    return this.GetBroker(broker_id);
  }
  updateBrokerAlgoRms(broker_id, params) {
    return sendRequestTardeManger('post', `broker/${broker_id}/algo/rms`, params, getHeaders())
  }

  getBrokerAlgoRms(broker_id) {
    return sendRequestTardeManger('get', `broker/${broker_id}/algo/rms`, {}, getHeaders())
  }

  specialSession() {
    return sendRequest('get', `get_special_session`, {}, getHeaders());
  }

  getMwplandBanListRequest = (date) => {
    return sendRequest(
      'get',
      `fno-mwpl?ban=true&date=${date}&entrants=true&exits=true`,
      {},
      getHeaders()
    );
  };

  loginStatusCheck() {
    return sendRequestTarde('get', `login-check`, {}, getHeaders());
  }

  getPackageList(parma) {
    const productType = parma?.product_type
    const path = productType
      ? `package-list?product_type=${encodeURIComponent(productType)}`
      : `package-list`;
    return sendRequestTarde('get', path, {}, getHeaders());
  }

  postStartUserTrial(type) {
    return sendRequestTarde('get', `start-user-trial?product_type=${type}`, {}, getHeaders());
  }

  applyPromoCode(parma) {
    return sendRequestTarde('post', `promo-code`, parma, getHeaders());
  }
  getSuscriptionOrderId(parma) {
    return sendRequestTarde('post', `initiate-subscription`, parma, getHeaders());
  }

  exitBrokerPositions(brokerId, param) {
    const query = param === "CE" ? "ignore_pe=true" : param === "PE" ? "ignore_ce=true" : ""
    return sendRequestTardeManger('post', `broker/${brokerId}/positions/exit?type=manual&${query}`, {}, getHeaders());
  }

  exitBasketPositions(basketId, param) {
    const query = param === "CE" ? "ignore_pe=true" : param === "PE" ? "ignore_ce=true" : ""
    return sendRequestTardeManger('post', `basket/${basketId}/positions/exit?type=manual&${query}`, {}, getHeaders());
  }

  exitPosition(positionId, orderQtyExit) {
    return sendRequestTardeManger('post', `position/${positionId}/exit?qty=${orderQtyExit}`, {}, getHeaders());
  }

  exitSelectedPositions(brokerId, positionIds) {
    return sendRequestTardeManger('post', `broker/${brokerId}/positions/exit?positions=${positionIds}`, {}, getHeaders());
  }

  syncSubscriptionStatus(orderId) {
    const formData = new FormData();
    formData.append("razorpay_order_id", orderId);
    return sendRequestTarde('post', 'razorpay-callback', formData, getHeaders());
  }

  getUserBrokerCount() {
    return sendRequestTarde('get', 'brokers/count', {}, getHeaders());
  }


  getUserStaticIPs() {
    return sendRequestTarde('get', 'static-ip', {}, getHeaders());
  }

  purchaseStaticIP(params) {
    return sendRequestTarde('post', 'static-ip/purchase', params, getHeaders());
  }

  assignStaticIP(params) {
    return sendRequestTarde('post', 'static-ip/assign', params, getHeaders());
  }

  unassignStaticIP(params) {
    return sendRequestTarde('post', 'static-ip/unassign', params, getHeaders());
  }

  renewStaticIP(params) {
    return sendRequestTarde('post', 'static-ip/renew', params, getHeaders());
  }

  staticIPPaymentCallback(params, userId) {
    return sendRequestTarde('post', `static-ip/payment-callback/${userId}`, params, getHeaders());
  }

  staticIPRenewalCallback(params, userId) {
    return sendRequestTarde('post', `static-ip/renewal-callback/${userId}`, params, getHeaders());
  }

  setBrokerPurpose(broker_id, purpose) {
    return sendRequestTarde('post', `brokers/${broker_id}/purpose`, { purpose }, getHeaders());
  }

  getBrokerQuiktrade(broker_id) {
    return sendRequestTardeManger('get', `broker/${broker_id}`, {}, getHeaders());
  }

}

export default new BrokerService();
